export default "__VITE_ASSET__726c7c4f__"